export default "__VITE_ASSET__DCdJQh2C__"